import { apiFetch, fetchWithAuthRetry } from './client'

export type StatementDirection = 'owner' | 'sub'

export interface StatementPreviewParams {
  direction: StatementDirection
  owner_name?: string
  owner_id?: number
  project_ids?: number[]
  project_id?: number
  sub_vendor_user_id?: number
  sub_label?: string
}

export interface StatementOwnerOption {
  owner_id: number | null
  owner_name: string
  open_total: number
}

export async function fetchStatementOwners(): Promise<StatementOwnerOption[]> {
  const res = await apiFetch<{ data: StatementOwnerOption[] }>('GET', '/api/statements/owners')
  return res.data || []
}

export async function fetchStatementPreview(params: StatementPreviewParams) {
  const q = new URLSearchParams()
  q.set('direction', params.direction)
  if (params.owner_name) q.set('owner_name', params.owner_name)
  if (params.owner_id != null) q.set('owner_id', String(params.owner_id))
  if (params.project_ids?.length) q.set('project_ids', params.project_ids.join(','))
  const res = await apiFetch<{ data: Record<string, unknown> }>('GET', `/api/statements/preview?${q}`)
  return res.data
}

export async function exportStatementPdf(body: StatementPreviewParams): Promise<Blob> {
  const res = await fetchWithAuthRetry('/api/statements/export', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
  if (!res.ok) throw new Error('Export failed')
  return res.blob()
}

export async function exportStatementBundle(body: StatementPreviewParams): Promise<Blob> {
  const res = await fetchWithAuthRetry('/api/statements/bundle', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
  if (!res.ok) throw new Error('Bundle failed')
  return res.blob()
}

export async function createStatementMagicLink(body: StatementPreviewParams) {
  const res = await apiFetch<{ data: { url: string; expires_at: string } }>(
    'POST',
    '/api/statements/magic-link',
    body,
  )
  return res.data
}

export interface StatementEmailResult {
  sent: boolean
  reason?: string
  recipient?: string
  magic_url?: string
}

export async function emailStatement(body: StatementPreviewParams & { to: string; email_pending?: boolean }) {
  const res = await apiFetch<{ data: StatementEmailResult; message?: string }>('POST', '/api/statements/email', body)
  return res.data
}

export interface StatementViewRow {
  viewed_at: string
  ip_address: string | null
  owner_name?: string | null
}

export async function fetchStatementRecentViews(projectId: number) {
  const res = await apiFetch<{ data: StatementViewRow[] }>(
    'GET',
    `/api/statements/recent-views?project_id=${projectId}`,
  )
  return res.data
}
